const timezonePattern = /(?:Z|[+-]\d{2}:?\d{2})$/i;
const sqliteDateTimePattern = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(?:\.\d+)?$/;

export function parseServerDate(dateString: string) {
  const trimmedDate = dateString.trim();
  const normalizedDate =
    sqliteDateTimePattern.test(trimmedDate) && !timezonePattern.test(trimmedDate)
      ? `${trimmedDate.replace(" ", "T")}Z`
      : trimmedDate;

  return new Date(normalizedDate);
}

export function formatLocalDateTime(dateString: string) {
  const date = parseServerDate(dateString);

  if (Number.isNaN(date.getTime())) {
    return "Unknown";
  }

  return date.toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

export function formatRelativeTime(dateString: string) {
  const date = parseServerDate(dateString);

  if (Number.isNaN(date.getTime())) {
    return "Unknown";
  }

  const diffInSeconds = Math.round((date.getTime() - Date.now()) / 1000);
  const absoluteDiffInSeconds = Math.abs(diffInSeconds);

  if (absoluteDiffInSeconds < 45) {
    return "just now";
  }

  const units: Array<[Intl.RelativeTimeFormatUnit, number]> = [
    ["minute", 60],
    ["hour", 60 * 60],
    ["day", 60 * 60 * 24],
    ["month", 60 * 60 * 24 * 30],
    ["year", 60 * 60 * 24 * 365],
  ];

  const [unit, secondsInUnit] =
    units.find(([, secondsInUnit]) => absoluteDiffInSeconds < secondsInUnit * 45) ?? units[units.length - 1];

  const value = Math.round(diffInSeconds / secondsInUnit);
  return new Intl.RelativeTimeFormat(undefined, { numeric: "auto" }).format(value, unit);
}
